export default function setupUnifiedHeaderDropdown(id) {
  setupDropdown(id)
}

function setupDropdown(id) {
  let opened = false
  const menuRef = document.querySelector(id)
  const menuTitles = menuRef.getElementsByClassName("menu-title")

  const updateOpenStatus = state => {
    opened = state
    if (opened) {
      menuRef.classList.add("open")
      menuRef.classList.remove("closed")
      window.document.addEventListener("click", closeMenu)
    } else {
      menuRef.classList.add("closed")
      menuRef.classList.remove("open")
      window.document.removeEventListener("click", closeMenu)
    }
  }

  const closeMenu = e => {
    if (!opened) return

    const isOutsideMenu = !menuRef.contains(e.target)

    if (isOutsideMenu) {
      updateOpenStatus(false)
    }
  }

  const flip = e => {
    const el = e.target
    if (el.classList.contains("item")) return

    updateOpenStatus(!opened)
  }

  for (let i = 0; i < menuTitles.length; i++) {
    menuTitles[i].addEventListener("click", flip)
  }
}
